import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa, PosTerminalDeviceContainerModel, PosTerminalService } from 'blg-akaun-ts-lib';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-multi-device-drop-down',
  templateUrl: './select-multi-device-drop-down.component.html',
  styleUrls: ['./select-multi-device-drop-down.component.css']
})
export class SelectMultiDeviceDropDownComponent implements OnInit, OnDestroy {

  @Input() device: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Device';
  @Input() options: any;

  @Output() deviceSelected = new EventEmitter<any>();

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "device";
  allSelected = false;
  filteredCache: any = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;
  
  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private terminalService: PosTerminalService, 
    private readonly store: Store<SessionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    console.log('ngOnChanges');
  }

  getRowData() {
    this.terminalService.get(this.apiVisa).subscribe(resolve => {
        let allOption = new PosTerminalDeviceContainerModel();
        allOption.bl_pos_terminal_device.guid = <any> 0;
        allOption.bl_pos_terminal_device.name = "ALL";
        this.rowData = [allOption, ...resolve.data]
        this.filteredOptions$.next(this.rowData.slice());
    });
    // let formData = {
    //   "limit" : null,
    //   "orderBy" : "code",
    //   "order" : "ASC",
    //   "filters" : {
    //        "namespace": "FI_ITEM_CATEGORY",
    //   }
    // }
    // this.dropDownService.get('device', formData, this.apiVisa).subscribe(resolved => {
    //   this.rowData = resolved.data;
    //   this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
    //   //fill the drop down
    //   this.filteredOptions$.next(this.rowData.slice());
    // });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(guid: string) {
    if (guid) {
      this.device.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.deviceSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.device.patchValue([...val.map(item => item.guid)]);
        } else {
          this.device.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.device && this.device.value) {
      this.filteredCache.forEach(el => {
        if (this.device.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
